import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Modal').create(({ theme }) => ({
  clickhelper: {
    width: '100vw',
    height: '100vh',
    position: 'absolute',
  },

  zIndex: {
    zIndex: 999,
  },
  backdrop: {
    height: '100vh',
    width: '100vw',
    position: 'fixed',
    top: '0',
    left: '0',
    gap: '12px',
    zIndex: '995',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    flexDirection: 'column',

    '&[data-open="false"]': {
      display: 'none',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '90%',
    padding: '24px',
    gap: '12px',
    zIndex: '999',
    bottom: '6vh',
    borderRadius: '12px',
    backgroundColor: '#2A2A2A',
    maxHeight: '90vh',
    marginBottom: '20px',
    '&[data-open="false"]': {
      display: 'none',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    justifyContent: 'space-between',
    width: '100%',
    gap: '12px',
    color: theme.colors.text.primary,
  },

  title: {
    textAlign: 'center',
    fontFamily: 'Inter',
    fontWeight: '550',
    fontSize: theme.sizes.texts.fontSize.l,
    fontStyle: 'normal',
    lineHeight: theme.sizes.texts.lineHeight.xl,

    textTransform: 'none',
    color: theme.colors.text.primary,
    position: 'relative',
  },

  closeBtn: {
    position: 'absolute',
    right: '0px',
    top: '0px',
  },

  text: {
    color: theme.colors.text.secondary,
    fontFamily: 'Inter',
    fontWeight: '400',
    fontSize: theme.sizes.texts.fontSize.s,
    fontStyle: 'normal',
    lineHeight: theme.sizes.texts.lineHeight.m,

    textTransform: 'none',
    textAlign: 'center',
  },
  btnContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '54px',
  },

  steamLogo: {
    width: '32px',
    height: '32px',
  },

  children: {},
}))
